export default __webpack_public_path__ + "static/UAE-0d85b181ab75e27534e8b46cb35280bc.png";